import { useQuery } from 'react-query';
import { navigateAcrossMFEs, useCurrentUser, useToastProvider } from '@qualio/ui-components';
import eventDetailsApi from '../api/eventDetails.api';
import { DefaultErrorMessage } from '../displayStrings';
import { useFlags } from '../external/LaunchDarklyAdapter';
import { isNotFoundError, wrongInstanceQri } from '../utils/errorUtils';

export const useEventDetails = (eventId: number) => {
  const { companyId } = useCurrentUser();
  const { showToast } = useToastProvider();
  const emailInstanceSwitch = useFlags('emailInstanceSwitch');

  return useQuery(['eventDetails', companyId, eventId], () => eventDetailsApi.getEventDetails(companyId, eventId), {
    enabled: !Number.isNaN(eventId) && eventId > 0,
    // A missing event is a terminal outcome: don't retry it (react-query defaults to 3),
    // and let the view render the not-found page instead of firing a generic error toast.
    // An event the user can only read in another company is terminal for the same reason.
    retry: (failureCount, error) => !isNotFoundError(error) && !wrongInstanceQri(error) && failureCount < 3,
    onError: (error) => {
      if (isNotFoundError(error)) {
        return;
      }
      const qri = wrongInstanceQri(error);
      if (qri) {
        if (emailInstanceSwitch) {
          navigateAcrossMFEs(`/switch-instance?qri=${encodeURIComponent(qri)}`);
        }
        return;
      }
      showToast({
        description: DefaultErrorMessage,
        status: 'error',
      });
    },
  });
};
